export enum AssetHistoryActionType {
    AssignToEmployee = 1,
    UnassignFromEmployee = 2,
    AssignToDepartment = 3,
    UnassignFromDepartment = 4,
    AssignToLocation = 5,
    UnassignFromLocation = 6
}